import { z } from 'zod';
import { AssistantSettingsDtoSchema } from './assistant-setting.dto';
import { GroupDtoSchema } from './group.dto';

export const PlaybookSchema = z
    .object({
        group: GroupDtoSchema.describe(
            'The group of the playbook, most contains system references and the name of the playbook',
        ),
        assistantSetting: AssistantSettingsDtoSchema.describe('The user defined settings for this playbook'),
    })
    .describe(
        'A playbook is a user defined set of instructions for an assistant to follow. It will contain information that he user have provided and want the system to know about when interacting with the contacts assigned to this playbook.',
    );
